<template>
  <div class="flex h-full">
    <h4 class="mr-8 flex items-center justify-center uppercase font-semibold">
      Empleados
    </h4>
    <router-link
      v-for="(menu, k) in options"
      v-bind:key="k"
      tag="span"
      :to="menu.path"
      class="
        cursor-pointer
        h-full
        p-2
        mx-2
        flex
        items-center
        justify-center
        -mb-2
      "
      exact-active-class="active"
      @click.native="$emit('clicked')"
    >
      <i :class="`el-icon-fa-${menu.icon} mr-2`"></i>
      {{ menu.name }}
    </router-link>
  </div>
</template>

<script>
import { checkPermissions } from "../../utils";

export default {
  name: "EmployeeSubMenu",
  data() {
    return {
      empleadosMenu: [
        {
          icon: "list-ul",
          path: "/employees/all",
          name: "Empleados",
          submodule: "Todos",
        },
        {
          icon: "clock-o",
          path: "/employees/overtime",
          name: "Asignar horas extra",
          submodule: "HorasExtra",
        },
        {
          icon: "bolt",
          path: "/employees/personal-actions",
          name: "Acciones de personal",
          submodule: "Acciones",
        },
        {
          icon: "graduation-cap",
          path: "/employees/trainings",
          name: "Capacitaciones",
          submodule: "Capacitaciones",
        },
      ],
    };
  },
  computed: {
    options() {
      return this.empleadosMenu.filter(
        (item) =>
          this.$store.getters.isSuper ||
          checkPermissions(`Empleados:${item.submodule}`, "Page:view") ||
          checkPermissions(`Empleados:${item.submodule}`, "Page:viewOwn")
      );
    },
  },
};
</script>
